import request from '@/utils/request';
import { newHost, musMerchantHost } from '@/global-config';

export function queryShopList(data) {
  return request({
    url: '/merchant-info/listShopMerchantPage',
    method: 'post',
    data,
  });
}

export function queryMerchantInfo(params) {
  return request({
    url: '/merchant-info/getMerchantInfo',
    method: 'get',
    params,
  });
}

export function queryMerchantRate(params) {
  return request({
    url: '/merchant-info/getMerchantRate',
    method: 'get',
    params,
  });
}

export function shopMerchantExport(data) {
  return request({
    baseURL: newHost,
    url: '/shopMerchant/export',
    method: 'post',
    data,
  });
}

export function getMerchantPosRefundConfig(data) {
  return request({
    baseURL: newHost,
    url: '/shopMerchant/getMerchantPosRefundConfig',
    method: 'post',
    data,
  });
}

export function updateMerchantPosRefundConfig(data) {
  return request({
    baseURL: newHost,
    url: '/shopMerchant/updateMerchantPosRefundConfig',
    method: 'post',
    data,
  });
}

/**
 * 查询商户成本费率详情（新版）
 * @param {*} data
 * @returns
 */
export function getMerchantCostFeeDetail(data) {
  return request({
    baseURL: musMerchantHost,
    url: '/merchant/info/getCostDetail',
    method: 'post',
    data,
  });
}
